import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';
import { LanguageToggle } from './LanguageToggle';
export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const {
    t
  } = useLanguage();
  const scrollToSection = (sectionId: string) => {
    setIsOpen(false);
    if (window.location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        element?.scrollIntoView({
          behavior: 'smooth'
        });
      }, 100);
    } else {
      const element = document.getElementById(sectionId);
      element?.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <nav className="fixed top-0 left-0 right-0 bg-navy text-white z-50 shadow-lg" data-id="element-104">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-105">
        <div className="flex justify-between items-center h-16" data-id="element-106">
          <Link to="/" className="text-lg font-serif font-bold" data-id="element-107">
            MerchantPro
          </Link>

          {/* Spacer and Language Toggle */}
          <div className="flex-grow flex justify-end md:justify-center pr-4 md:pr-0" data-id="element-108">
            <div className="hidden md:block" data-id="element-109">
              <LanguageToggle data-id="element-110" />
            </div>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-111">
            <button onClick={() => scrollToSection('inicio')} className="hover:text-gold transition-colors whitespace-nowrap" data-id="element-112">
              {t('nav.inicio')}
            </button>
            <button onClick={() => scrollToSection('servicios')} className="hover:text-gold transition-colors whitespace-nowrap" data-id="element-113">
              {t('nav.servicios')}
            </button>
            <button onClick={() => scrollToSection('como-funciona')} className="hover:text-gold transition-colors whitespace-nowrap" data-id="element-114">
              {t('nav.comoFunciona')}
            </button>
            <Link to="/contacto" className="hover:text-gold transition-colors whitespace-nowrap" data-id="element-115">
              {t('nav.contacto')}
            </Link>
            <Link to="/contacto" className="bg-gold text-navy px-6 py-2 rounded-md font-semibold hover:bg-opacity-90 transition-all whitespace-nowrap" data-id="element-116">
              {t('nav.evaluacionGratis')}
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button onClick={() => setIsOpen(!isOpen)} className="md:hidden p-2" aria-label="Toggle menu" data-id="element-117">
            {isOpen ? <X size={24} data-id="element-118" /> : <Menu size={24} data-id="element-119" />}
          </button>
        </div>
      </div>

      {/* Mobile Navigation */}
      <AnimatePresence data-id="element-120">
        {isOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-darkGray" data-id="element-121">
            <div className="px-4 py-4 space-y-3" data-id="element-122">
              <div className="pb-3 border-b border-gray-700 flex justify-center" data-id="element-123">
                <LanguageToggle data-id="element-124" />
              </div>
              <button onClick={() => scrollToSection('inicio')} className="block w-full text-left py-2 hover:text-gold transition-colors" data-id="element-125">
                {t('nav.inicio')}
              </button>
              <button onClick={() => scrollToSection('servicios')} className="block w-full text-left py-2 hover:text-gold transition-colors" data-id="element-126">
                {t('nav.servicios')}
              </button>
              <button onClick={() => scrollToSection('como-funciona')} className="block w-full text-left py-2 hover:text-gold transition-colors" data-id="element-127">
                {t('nav.comoFunciona')}
              </button>
              <Link to="/contacto" onClick={() => setIsOpen(false)} className="block py-2 hover:text-gold transition-colors" data-id="element-128">
                {t('nav.contacto')}
              </Link>
              <Link to="/contacto" onClick={() => setIsOpen(false)} className="block bg-gold text-navy px-6 py-2 rounded-md font-semibold text-center hover:bg-opacity-90 transition-all" data-id="element-129">
                {t('nav.evaluacionGratis')}
              </Link>
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}